import { Consultations, getStaticProps } from '@public/Consultations'

export { getStaticProps }

export default Consultations
